module.exports = "/assets/data/a7afab4f94188b7388f189775d9e33db-UB6.data.json";